import { useTranslation } from "react-i18next";
import "./index.css"
import { Container } from "react-bootstrap";
import * as ReactBootstrap from "react-bootstrap";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import ExitModalAndSave from "../Modal/ExitModalAndSave";
import { useHistory } from "react-router-dom";
import { useSelector,useDispatch } from "react-redux";
import { repairPriorityDetermination } from "../../api";
import { CreateHazardRequest, HazardResponseRequest, SavedHazardAssessment } from "../../models/ReferenceData/HazardAssessment";
import { repairPriorityRequest } from "../../models/Repair/RepairReason";
import { RepairChannel } from "../../models/Repair/RepairChannel";
import { priorityCode } from '../../ducks/redux/actions/dashboardReducer.actions';
import { workOrderRepairObject } from "../../ducks/redux/actions/getAddress";
import { RepairPriorityCode } from "../../models/Repair/CreateRepair";
import moment from "moment";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import * as api from "../../api";
import { saveHazardAssessment, saveHazardPostAssessmentResponse, saveHHSRSAssessmentCompleted, saveStandardRepairPriority } from '../../ducks/redux/actions/hazardAssessment';
import { isMobile } from "react-device-detect";
import { useEffect, useState, useRef } from "react";
import { MaintenanceResponsibilityEnum } from "../../models/Property/MaintenanceResponsibilityEnum";
import { Helper } from "../../utils/Helper/HelperUtil";
import LoadingSpinner from "../../storybook/LoadingSpinner";
const normaliseRequest = (request: CreateHazardRequest) => ({
  assetType: request.assetType.toUpperCase(),
  hazardType: request.hazardType,
  contractorRating: request.contractorRating,
  hasAdditionalNeeds: request.hasAdditionalNeeds,
  isSupportedResident: request.isSupportedResident,
  responses: request.responses.map((response) => ({ code: response.code, answers: [...response.answers].sort((first, second) => first.localeCompare(second)) }))
    .sort((first, second) => first.code.localeCompare(second.code)),
});

const hasAssessmentChanged = (saved: SavedHazardAssessment | null | undefined, identifier: string | undefined,
  request: CreateHazardRequest): boolean => !saved || saved.identifier !== identifier ||
  JSON.stringify(normaliseRequest(saved.request)) !== JSON.stringify(normaliseRequest(request));

const getIsEmergencyOverride = (
  resolvedPriorityCode: string | undefined,
  priorityIsEmergency: boolean
): boolean => {
  if (resolvedPriorityCode === RepairPriorityCode.AWAABSLAWEMERGENCY) {
    return true;
  }

  if (
    resolvedPriorityCode === RepairPriorityCode.AWAABSLAWLOW ||
    resolvedPriorityCode === RepairPriorityCode.AWAABSLAWSIGNIFICANT
  ) {
    return false;
  }

  return priorityIsEmergency;
};

const HazardReview = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [isSaving, setIsSaving] = useState(false);
  const savingRef = useRef(false);
  const savedAssessment = useSelector((state: any) => state?.hazard?.savedAssessment);
  const hazardDetails = useSelector((state: any) => state?.hazard?.responses);
  const hazardQuestions = useSelector((state: any) => state?.hazard?.hazardQuestions || []);
  const assessmentDetails = hazardDetails?.filter((item: any) => !item.isPreAssessment && item.answerCodes?.length) || [];
  const isAdditionalNeedsUser = useSelector((state: any) => state?.userChoicesReducer?.hasAdditionalNeeds);
  const supportedResident = useSelector((state: any) => state?.userChoicesReducer?.isSupportedResident);
  const selectedRepairReasonObj = useSelector((state: any) =>state?.dashboardReducer?.formState?.selectedRepairReasonObject);
  const assetDetails = useSelector((state: any) =>state.dashboardReducer?.formState?.assetByIdDataObject);
  const workOrderObject = useSelector((state: any) => state?.addresses?.workOrderRepair);
  const userMaintResp = useSelector((state: any) => state?.addresses?.maintresp);
  const userSelectedRepairResp = useSelector((state: any) => state?.addresses?.repairresp);
  const customerAdditionalAlertData = useSelector((state: any) => state?.userChoicesReducer?.customerAdditionalAlertData);
  const isAnaTypeValue = customerAdditionalAlertData?.length > 0 ;
  const customerDetails = useSelector((state: any) => state?.addresses?.saveCustomerDetails);
  const isEnhancedDiagnosticsRepair = workOrderObject?.isEnhancedDiagnosticsRepair;
  const repairDiagnosticData = useSelector((state: any) => state?.userChoicesReducer?.repairDiagnosticFinalData);
  const selectedRepairReasonObject = useSelector((state: any) => state?.dashboardReducer?.formState?.selectedRepairReasonObject);
  const selectedRepairReasonPriorityOverride = useSelector((state: any) => state?.dashboardReducer?.formState?.selectedRepairReasonPriorityOverride);
  const selectedPriorityCode = useSelector((state: any) => state?.dashboardReducer?.formState?.priorityCode);
  const standardRepairPriority = useSelector((state: any) => state?.hazard?.standardRepairPriority);
  const isHHSRSAssessmentCompleted = useSelector((state: any) => state?.hazard?.isHHSRSAssessmentCompleted);
  
  const userChosenSOR = useSelector((state: any) => state?.userChoicesReducer?.userChosenSOR);
  const priorityWorkProgramme = userChosenSOR !== ""
            ? (selectedRepairReasonObject?.[0]?.sors?.find((sor: any) => sor?.sorCode === userChosenSOR)?.workProgramme
              ?? selectedRepairReasonObject?.[0]?.sors?.[0]?.workProgramme)
            : selectedRepairReasonObject?.[0]?.sors?.[0]?.workProgramme;
    //if pre assessment outcome is Hazard the always take default priority      
  const defaultPriorityIsEmergency = [
    RepairPriorityCode.Emergency,
    "Emergency",
    "Emergency (OOH)",
  ].includes(selectedRepairReasonObject?.[0]?.priority);

  //get default Emergency when if pre assessment outcome is Hazard otherwise take whatever AR1 changed
  const isPreAssessmentHazard =
    selectedRepairReasonObject?.[0]?.isPreAssessmentRequired === true;
  const priorityIsEmergency = isPreAssessmentHazard
    ? defaultPriorityIsEmergency
    : workOrderObject?.isEmergency;

   const navigateTo = (path: string) => {
        history.push(path);
      };
  const handleContinue = async () => {
    if (savingRef.current || assessmentDetails.length === 0) return;
    savingRef.current = true;
    setIsSaving(true);
    try {
      const request = createHazardAssessmentRequest();
      const identifier = workOrderObject?.assessmentInformation?.identifier || workOrderObject?.assessmentIdentifier;
      const assessmentChanged = hasAssessmentChanged(savedAssessment, identifier, request);
      const priorityChanged = !savedAssessment || savedAssessment.repairType !== userChosenSOR ||
        savedAssessment.isEmergency !== priorityIsEmergency;
      if (!assessmentChanged && !priorityChanged && workOrderObject?.hhsrsAssessment) {
        dispatch(saveHHSRSAssessmentCompleted(true));
        navigateTo("/RepairUploadmedia");
        return;
      }
      const hazardAssessmentResponse = assessmentChanged
        ? await persistHazardAssessment(request)
        : [savedAssessment.outcome];
      dispatch(saveHazardPostAssessmentResponse(hazardAssessmentResponse[0]));
    
      const repairPriorityResponse = await callRepairPriorityDetermination(hazardAssessmentResponse);
      const resolvedPriorityCode = repairPriorityResponse?.repairPriority;
      if (!resolvedPriorityCode) {
        throw new Error("Repair priority was not returned");
      }
      if (!standardRepairPriority && !isHHSRSAssessmentCompleted) {
        dispatch(saveStandardRepairPriority({
          priorityCode: selectedPriorityCode || "",
          priorityOverride: selectedRepairReasonPriorityOverride || "",
          workOrderPriority: workOrderObject?.priority || "",
          isEmergency: Boolean(workOrderObject?.isEmergency),
        }));
      }
      dispatch(priorityCode(resolvedPriorityCode));
      //get priority value from Enum via prioritycode     
       
      await UpdateWorkOrder(hazardAssessmentResponse, resolvedPriorityCode);
      dispatch(saveHazardAssessment({
        identifier: hazardAssessmentResponse[0].id,
        request,
        outcome: hazardAssessmentResponse[0],
        repairType: userChosenSOR,
        isEmergency: priorityIsEmergency,
      }));
      dispatch(saveHHSRSAssessmentCompleted(true));

      // navigate to next page only after all APIs succeed
      navigateTo("/RepairUploadmedia");
    } catch (e) {
      console.error(e);
      navigateTo("/GenericError");
    } finally {
      savingRef.current = false;
      setIsSaving(false);
    }
  };

  useEffect(()=>{
    if(isMobile)globalThis.scroll(0,0);
  },[])

  const getAssessmentPageNumber = (questionCode: string) => {
    const questionIndex = hazardQuestions.findIndex((question: any) => question.code === questionCode);
    return questionIndex === -1 ? -1 : questionIndex + 1;
  };

  const backButtonHandler = () => {
    const isPreAssessmentBackNavigationEligible =
      assetDetails?.statuses?.isInDefects !== true &&
      userMaintResp !== MaintenanceResponsibilityEnum.EMAFULL &&
      userSelectedRepairResp !== MaintenanceResponsibilityEnum.EMAFULL;

    if (
      selectedRepairReasonObj?.[0]?.isPreAssessmentRequired === true &&
      !isPreAssessmentBackNavigationEligible
    ) {
      history.push("/RepairAdditionalDetails");
      return;
    }

    let lastAnsweredAssessmentPage = -1;

    assessmentDetails.forEach((item: any) => {
      if (!item.answerCodes?.length) {
        return;
      }

      const pageNumber = getAssessmentPageNumber(item.code);
      if (pageNumber > lastAnsweredAssessmentPage) {
        lastAnsweredAssessmentPage = pageNumber;
      }
    });

    if (lastAnsweredAssessmentPage !== -1) {
      history.push(`/HazardAssessment/${lastAnsweredAssessmentPage}`);
      return;
    }

    if (selectedRepairReasonObj?.[0]?.isPreAssessmentRequired === true) {
      history.push("/HazardPreassessment");
      return;
    }

    history.push("/RepairAdditionalDetails");
  };
  const exitButtonHandler = () => {
     history.push("/LandingView");
  }

  const saveDraftAndExit = () => history.push(`/WorkOrder360View/${workOrderObject.id}`);

const handleEdit = (item: any) => {
  if (savingRef.current) return;
  if (item.isPreAssessment) {
    history.push(`/HazardAssessment/${item.sequence}`);
    return;
  }

  const pageNumber = getAssessmentPageNumber(item.code);
  if (pageNumber !== -1) {
    history.push(`/HazardAssessment/${pageNumber}`);
  }
};

  const renderDesktopHazardDetails = () => {
  return (
    <div className="mb-16 container">
        <div className="repair-text " id="confirmation-div-table">
            <ReactBootstrap.Table className="container-new">
              <TableBody
                id="confirmation-table"
                className="w-full border border-grey"
              >
                {assessmentDetails?.map((item: any) => (
                  <TableRow
                    key={item.sequence}
                    className={`flex items-center bg-white ${
                      assessmentDetails?.length - 1 ? "border-b border-gray-300" : ""
                    }`}
                  >
                    <TableCell className="w-2/3 p-3 firstcol">
                      <div className="text-base padding-new color_black global-txt">
                        {item.question}
                      </div>
                    </TableCell>
                      <TableCell className="w-2/3 p-3 thirdcol paddright ">
                      <div className="edt-spc padding-new pr-8 flex flex-wrap gap-2">
                        {item.answers.map((answer: any) => (
                          <span
                            key={`${item.sequence}-${item.code}-${answer}`}
                            className="cellTextColor"
                          >
                            {answer}
                          </span>
                        ))}
                      </div>
                    </TableCell>
                    <TableCell className="w-2/3 p-3 thirdcol paddright">
                      <div className="edt-spc padding-new text-right pr-8">
                        <button
                          type={undefined}
                          data-testid="hazard-question-edit-icon"
                          className="bg-transparent border-0 p-0 m-0 text-teal text-lg cursor-pointer"
                          title={t("confirmation_edit")}
                          aria-label={t("confirmation_edit")}
                          onClick={() => handleEdit(item)}
                        >
                          <i
                            className="fas fa-edit"
                            aria-hidden="true"
                          ></i>
                        </button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}

              </TableBody>
            </ReactBootstrap.Table>
    </div>
  </div>
  )
}

const renderMobileHazardDetails = () => {
  return (
    <div className="hazard-mobile-list px-2">
      {assessmentDetails?.map((item: any) => (
        <div className="hazard-mobile-card mb-3" key={item.sequence}>
          <p className="hazard-mobile-question mb-3">{item.question}</p>

          <div className="hazard-mobile-answers mb-3">
            {item.answers?.map((answer: any, idx: number) => (
              <span
                key={`${item.sequence}-${item.code}-${answer}-${idx}`}
                className="hazard-mobile-chip"
              >
                {answer}
              </span>
            ))}
          </div>

          <button
            type={undefined}
            className="hazard-mobile-edit-btn bg-transparent border-0 p-0 m-0 text-teal text-lg cursor-pointer"
            onClick={() => handleEdit(item)}
            aria-label={t("confirmation_edit")}
          >
            <i className="fas fa-edit mr-1" aria-hidden="true"></i>
            {t("confirmation_edit")}
          </button>
        </div>
      ))}
    </div>
  );
};
const callRepairPriorityDetermination = async (hazardAssessmentResponse:any) => {
  try {
    const assessmentOutcome = hazardAssessmentResponse?.[0];
    if (!assessmentOutcome?.hazardType || !assessmentOutcome?.risk?.adjusted) {
      throw new Error("Hazard assessment type or adjusted risk was not returned");
    }

    const payload: repairPriorityRequest = {
      isEmergency: priorityIsEmergency,
      repairType: userChosenSOR,
      description: workOrderObject?.repairReason,
      channel: RepairChannel.ColleagueSelfServe,
      raisedDate: moment(new Date()).format("YYYY-MM-DDTHH:mm:ss"),
      premisesType: assetDetails?.assetType,
      riskRating: assessmentOutcome.risk.adjusted,
      assessmentType: assessmentOutcome.hazardType,
      isAnaType: isAnaTypeValue,
      isV14Upgradable: isEnhancedDiagnosticsRepair ? repairDiagnosticData?.isV14Eligibile : selectedRepairReasonObject?.[0]?.isV14Upgradable,
      tenureCode: customerDetails?.tenanciesSummaries?.[0]?.tenancySummary?.tenancyTenureCode ?? "",
      workProgramme: isEnhancedDiagnosticsRepair ? repairDiagnosticData?.workProgram : priorityWorkProgramme,
    };
   const repairPriorityDeterminationResponse = await repairPriorityDetermination(payload);
   return repairPriorityDeterminationResponse;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const createHazardAssessmentRequest = (): CreateHazardRequest => {
  const hazardType = selectedRepairReasonObj?.[0]?.hazardType;
  if (!assetDetails?.assetType || !hazardType) {
    throw new Error("Asset type or hazard type is missing");
  }

  const responses: HazardResponseRequest[] = hazardDetails?.filter((item: any) => item.answerCodes?.length).map((item: any) => ({
    code: item.code,
    answers: item.answerCodes
  })) || [];

  return {
    assetType: assetDetails.assetType,
    hazardType,
    contractorRating: null,
    hasAdditionalNeeds: Boolean(isAdditionalNeedsUser),
    isSupportedResident: Boolean(supportedResident),
    responses
  };
};

const persistHazardAssessment = async (request: CreateHazardRequest) => {
    try {
      const assessmentIdentifier = workOrderObject?.assessmentInformation?.identifier || workOrderObject?.assessmentIdentifier;
      const response = assessmentIdentifier
        ? [await api.updateHazardAssessment(assessmentIdentifier, request)]
        : await api.createHazardAssessment(request);
      const assessmentOutcome = response?.[0];
      if (!assessmentOutcome?.id || !assessmentOutcome.hazardType || !assessmentOutcome.risk?.adjusted || !assessmentOutcome.score) {
        throw new Error("Hazard assessment outcome is incomplete");
      }
      if (assessmentIdentifier && assessmentOutcome.id !== assessmentIdentifier) {
        throw new Error("Hazard assessment identifier changed");
      }
      // Retain the identifier if priority or work-order persistence fails, so retry uses PATCH.
      workOrderObject.assessmentIdentifier = assessmentOutcome.id;
      dispatch(workOrderRepairObject({ ...workOrderObject }));
      return response;
    }
    catch (e) {
      console.error(e);
      throw e;
    }};
 const UpdateWorkOrder = async (hazardAssessmentResponse?: any, resolvedPriorityCode?: string) => {
    try {
      const assessmentOutcome = hazardAssessmentResponse?.[0];
      const hazardInspectionSorCode = selectedRepairReasonObject?.[0]?.hazardSorCode;
      const isEmergencyOverride = getIsEmergencyOverride(
        resolvedPriorityCode,
        priorityIsEmergency
      );

      if (
        !assessmentOutcome?.id ||
        !assessmentOutcome?.hazardType ||
        !assessmentOutcome?.risk ||
        !assessmentOutcome?.score
      ) {
        throw new Error("Hazard assessment outcome is incomplete");
      }
      if (!hazardInspectionSorCode) {
        throw new Error("Hazard inspection SOR code is missing");
      }
      if (!resolvedPriorityCode) {
        throw new Error("Repair priority is missing");
      }

      workOrderObject.priority = resolvedPriorityCode;
      workOrderObject.priorityCode = resolvedPriorityCode;
      workOrderObject.isEmergency = isEmergencyOverride;
      workOrderObject.hazardSorCode = hazardInspectionSorCode;      
      workOrderObject.assessmentIdentifier = assessmentOutcome.id;
      workOrderObject.hhsrsAssessment = {
        category: assessmentOutcome.hazardType,
        severity: assessmentOutcome.risk.adjusted
      };
      workOrderObject.repairCauseId = Helper.HHSRSRepairCauseId;
      workOrderObject.repairCause =
       Helper.RepairCauseLabels[Helper.HHSRSRepairCauseId];
    

      saveAssessmentInformation(assessmentOutcome);
      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      const woRequestParameters =
        _worksOrderRequest.updateWorkOrderParameter(workOrderObject);
      await api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      );
      dispatch(workOrderRepairObject(workOrderObject));
    } catch (e) {
      console.error(e);
      throw e;
    } 
  };

  const saveAssessmentInformation = (assessmentOutcome: any) => {
    const assessmentInformation = {
      type: assessmentOutcome.hazardType,
      communicationPreference: workOrderObject?.assessmentInformation?.communicationPreference ?? null,
      outcome: {
        riskRating: assessmentOutcome.risk.overall,
        adjustedRiskRating: assessmentOutcome.risk.adjusted,
        vulnerabilityRiskRating: assessmentOutcome.risk.vulnerability,
        vulnerabilityScore: assessmentOutcome.score.vulnerability,
        totalScore: assessmentOutcome.score.combined
      },
      hasAdditionalNeeds: Boolean(isAdditionalNeedsUser),
      isSupportedResident: Boolean(supportedResident),
      identifier: assessmentOutcome.id
    }
    workOrderObject.assessmentInformation = assessmentInformation;
  }

  if (isSaving) {
    return (
      <Container id="preAssessment" role="main" className="ctn-fht px-3">
        <div className="div-loader marign-left-smallscreen-0">
          <div className="SpinnerWrapper" id="SpinnerWrapper">
            <LoadingSpinner />
          </div>
        </div>
      </Container>
    );
  }

  return (
      <Container id="preAssessment" role="main" className="ctn-fht px-3">
      <div className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0">
        <div className="back-and-journey">
          <p id="back-button-presassement" className="text-teal text-xl mt-4">
            <button
              className="back-button_hazard"
              data-testid="backButtonHandler"
              onClick={backButtonHandler}
              disabled={isSaving}
              type="submit"
            >
              <i className="fas fa-angle-left mr-2"></i>
              {t("back")}
            </button>
          </p>
        </div>
      </div>
    
      <div id="confirmation-main-div" className="global-txt">
              <h2 id="confirmation-h1" className="text-purple-100 text-2xl mb-2 ml-2">
                {t("Hazard_Review_Title")}
              </h2>
      </div>
      <div className="global-txt ml-2 mb-4">{t("Hazard_Review_Sub_Title")}</div>
      <div className="ReviewHeaderText mb-4">{t("Hazard_Review_Head_Msg")}</div>
      {assessmentDetails?.length > 0 && (
        <>
          <div className="d-block d-md-none">
            {renderMobileHazardDetails()}
          </div>
          <div className="d-none d-md-block">
            {renderDesktopHazardDetails()}
          </div>
        </>
      )}

          <div className="flex justify-between items-center gap-4 pb-4 ml-2" id="assessment-main-btn">
        <div className="flex-1">
          <ExitModalAndSave
            id="repreason-exitmodal"
            exit={exitButtonHandler}
            saveDraftAndExit={saveDraftAndExit}
            disabled={isSaving}
          />
        </div>

       <div className="col-md-12 marginTop-auto mt-4 mb-4">
          <div className="row m-0 footer-actionbtn">
            <div className="col text-end padding-repair">
              <button
                className="button-class"
                id="btn_hhrs_continue"
                onClick={handleContinue}
                type="button"
                disabled={isSaving || assessmentDetails.length === 0}
                aria-busy={isSaving}
              >
                {t("continue")}
                <i className="fas fa-angle-right relativetext-white pointer-events-none arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* End button */}

    </Container>
  );
};
export { HazardReview };
